"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var core_1 = require("@material-ui/core");
var CustomCheckbox = function (_a) {
    var label = _a.label, value = _a.value, onChange = _a.onChange, onClick = _a.onClick, dataTest = _a["data-test"];
    var intl = react_intl_1.useIntl();
    var handleChange = react_1.useCallback(function (event) {
        onChange && onChange(event.target.checked);
    }, []);
    return (<core_1.FormControlLabel data-test={dataTest} label={<core_1.Typography dangerouslySetInnerHTML={{
        __html: intl.formatMessage({ id: label }),
    }}/>} control={<core_1.Checkbox value={value} onClick={onClick} onChange={handleChange}/>}/>);
};
exports.default = CustomCheckbox;
